import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nvidiaNgc = defineConnector({
  identifier: "nvidiaNgc",
  name: "NVIDIA NGC",
  tagLine: "GPU software, models, and registry APIs",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "data"],
  defaultUrlPattern: () => "https://api\\.ngc\\.nvidia\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key in NVIDIA NGC",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [NGC API Keys page](https://org.ngc.nvidia.com/setup/personal-keys), generate a personal or service API key, and copy it.",
        },
      ],
    },
    {
      title: "Enter your NGC API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          helperText: "Paste the API key from NVIDIA NGC.",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.ngc.nvidia.com/v2/org/nvidia/repos/pytorch/images/26.01-py3-igpu/vex",
  },
});
